import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { useTheme } from '@mui/material/styles';
import { useReviewContext } from '../../../../Context';
export default function AuthorsAndEditorsPictures() {
  const $ = _c(8);
  const {
    authors
  } = useReviewContext();
  const {
    palette
  } = useTheme();
  if (!authors || authors.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== authors || $[1] !== palette) {
    let t1;
    if ($[3] !== authors.length || $[4] !== palette) {
      t1 = (author, index) => <CdnImage key={author.id} src={author.image.url} alt={`${author.name} Author Avatar`} height={40} width={40} style={{
        border: "1px solid white",
        borderRadius: "50%",
        backgroundColor: palette.neutral.lightest,
        marginLeft: index > 0 ? "-12px" : 0,
        zIndex: authors.length - index,
        position: "relative"
      }} />;
      $[3] = authors.length;
      $[4] = palette;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    t0 = authors.map(t1);
    $[0] = authors;
    $[1] = palette;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[6] !== t0) {
    t1 = <>{t0}</>;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}